/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_TitleInputs */

const en_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Styling`)
};

const fr_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style des sous-titres`)
};

const de_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformatierung`)
};

const it_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile dei sottotitoli`)
};

const ru_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оформление субтитров`)
};

const es_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de subtítulos`)
};

const zh_cn2_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕样式`)
};

const ja_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のスタイル`)
};

const hi_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक शैलीकरण`)
};

const pt_pt2_video_export_style_title = /** @type {(inputs: Video_Export_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilização de legendas`)
};

/**
* | output |
* | --- |
* | "Subtitle Styling" |
*
* @param {Video_Export_Style_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_title = /** @type {((inputs?: Video_Export_Style_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_style_title(inputs)
	if (locale === "de") return de_video_export_style_title(inputs)
	if (locale === "it") return it_video_export_style_title(inputs)
	if (locale === "ru") return ru_video_export_style_title(inputs)
	if (locale === "es") return es_video_export_style_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_style_title(inputs)
	if (locale === "ja") return ja_video_export_style_title(inputs)
	if (locale === "hi") return hi_video_export_style_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_style_title(inputs)
	return en_video_export_style_title(inputs)
});